import React, { useEffect, useState } from "react";

import { useTheme } from '../../App';

import { NavLink } from 'react-router-dom';

import { motion } from 'framer-motion';

import BackButton from '../../components/common/BackButton/BackButton';

import { getFooterSettings } from '../../services/settingsCache';

import { apiClient } from '../../services/apiClient';

import delhiImage from '../../assets/images/cities/delhi.png';

import mumbaiImage from '../../assets/images/cities/mumbai.png';

// import contactPageImage from '../../assets/images/ContactPage.png';

import './Contact.css';

function PhoneCallSvgIcon({ width = 16, height = 16, stroke = "currentColor", style = {} }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none" style={style}>
      <g clipPath="url(#clip0_26_4142)">
        <path d="M9.22198 11.0454C9.35967 11.1086 9.51478 11.1231 9.66178 11.0863C9.80877 11.0496 9.93887 10.9639 10.0307 10.8434L10.2673 10.5334C10.3915 10.3678 10.5526 10.2334 10.7377 10.1408C10.9228 10.0482 11.127 10 11.334 10H13.334C13.6876 10 14.0267 10.1405 14.2768 10.3906C14.5268 10.6406 14.6673 10.9798 14.6673 11.3334V13.3334C14.6673 13.687 14.5268 14.0261 14.2768 14.2762C14.0267 14.5262 13.6876 14.6667 13.334 14.6667C10.1514 14.6667 7.09914 13.4024 4.8487 11.152C2.59827 8.90155 1.33398 5.8493 1.33398 2.66671C1.33398 2.31309 1.47446 1.97395 1.72451 1.7239C1.97456 1.47385 2.3137 1.33337 2.66732 1.33337H4.66732C5.02094 1.33337 5.36008 1.47385 5.61013 1.7239C5.86017 1.97395 6.00065 2.31309 6.00065 2.66671V4.66671C6.00065 4.8737 5.95246 5.07785 5.85989 5.26299C5.76732 5.44813 5.63291 5.60918 5.46732 5.73337L5.15532 5.96737C5.03293 6.06083 4.94666 6.19376 4.91118 6.34361C4.87569 6.49345 4.89317 6.65096 4.96065 6.78937C5.87177 8.63995 7.37027 10.1366 9.22198 11.0454Z" stroke={stroke} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_26_4142">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}



const defaultContactHeroBackground =

  "linear-gradient(to right, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.65) 40%, rgba(0,0,0,0.35) 70%, rgba(0,0,0,0.2) 100%), url('/assets/images/Container.png')";



export default function Contact() {

  const { isNightMode } = useTheme();

  const [settings, setSettings] = useState(null);
  const [contactContent, setContactContent] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showCallbackModal, setShowCallbackModal] = useState(false);
  const [callbackData, setCallbackData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    preferredTime: ''
  });
  const [callbackStatus, setCallbackStatus] = useState('');

  useEffect(() => {
    let cancelled = false;

    const loadContent = async () => {
      try {
        // Load contact page content from content management API
        const contactData = await apiClient.get('/content/contact').catch(() => null);
        if (!cancelled && contactData) {
          setContactContent(contactData);
        }

        // Also load general footer settings for contact info
        const settingsData = await getFooterSettings();
        if (!cancelled && settingsData) {
          setSettings(settingsData);
        }
      } catch (err) {
        console.error('Failed to load contact content', err);
      }
    };

    loadContent();

    return () => {
      cancelled = true;
    };
  }, []);



  const handleInputChange = (e) => {

    const { name, value } = e.target;

    setFormData(prev => ({

      ...prev,

      [name]: value

    }));

  };



  const handleSubmit = async (e) => {

    e.preventDefault();

    // Store data before clearing
    const originalFormData = { ...formData };

    // INSTANT SUCCESS - Show success immediately
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
    setSubmitStatus('Message sent successfully! We will get back to you soon.');
    
    // Clear success message after 2 seconds
    setTimeout(() => setSubmitStatus(''), 2000);

    // Process in background WITHOUT blocking UI
    (async () => {
      try {
        await apiClient.post('/contact', {
          name: originalFormData.name,
          email: originalFormData.email,
          phone: originalFormData.phone,
          subject: originalFormData.subject,
          message: originalFormData.message
        });
        // Success - no action needed as we already showed success
      } catch (error) {
        console.error('Background submission failed:', error);
        // If background fails, show error and restore form
        setFormData(originalFormData);
        setSubmitStatus('Failed to send message. Please try again.');
        setTimeout(() => setSubmitStatus(''), 3000);
      }
    })();

  };

  const handleSubmitCallback = async () => {
    // Validation
    if (!callbackData.name.trim() || !callbackData.phone.trim()) {
      setCallbackStatus('Please fill in all required fields (Name and Phone)');
      setTimeout(() => setCallbackStatus(''), 3000);
      return;
    }

    // Store data before clearing
    const originalCallbackData = { ...callbackData };

    // INSTANT SUCCESS - Show success immediately
    setCallbackData({
      name: '',
      email: '',
      phone: '',
      message: '',
      preferredTime: ''
    });
    setCallbackStatus('Callback request submitted successfully! We will contact you soon.');
    
    // Close modal after 1 second and clear status
    setTimeout(() => {
      setShowCallbackModal(false);
      setCallbackStatus('');
    }, 1000);

    // Process in background WITHOUT blocking UI
    (async () => {
      try {
        await apiClient.post('/callback-requests', {
          name: originalCallbackData.name,
          email: originalCallbackData.email,
          phone: originalCallbackData.phone,
          message: originalCallbackData.message,
          preferredTime: originalCallbackData.preferredTime,
          status: 'pending',
          createdAt: new Date().toISOString()
        });
        // Success - no action needed as we already showed success
      } catch (error) {
        console.error('Background submission failed:', error);
        // If background fails, show error and restore form
        setCallbackData(originalCallbackData);
        setCallbackStatus('Failed to submit callback request. Please try again or contact us directly.');
        setTimeout(() => setCallbackStatus(''), 5000);
      }
    })();
  };

  const contactHeroBackground = (contactContent && contactContent.heroImageUrl) || (settings && settings.contactHeroImageUrl)
    ? `linear-gradient(to right, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.65) 40%, rgba(0,0,0,0.35) 70%, rgba(0,0,0,0.2) 100%), url('${(contactContent && contactContent.heroImageUrl) || (settings && settings.contactHeroImageUrl)}')`
    : defaultContactHeroBackground;

  const heroBadge = (contactContent && contactContent.heroBadge) || (settings && settings.contactHeroBadge) || 'Get In Touch';

  const heroTitle = (contactContent && contactContent.heroTitle) || (settings && settings.contactHeroTitle) || 'Contact Us';

  const heroSubtitle = (contactContent && contactContent.heroSubtitle) || (settings && settings.contactHeroSubtitle) || "Have questions? We're here to help. Reach out to our team for expert guidance and support.";



  const contactMainPhoneLabel = settings?.companyPrimaryPhone || (contactContent && contactContent.mainPhone) || settings?.contactMainPhoneLabel || '06214418345';
  const contactAltPhoneLabel = settings?.companySecondaryPhone || settings?.contactAltPhoneLabel || '';
  const contactPhoneHref = contactMainPhoneLabel ? `tel:${contactMainPhoneLabel.replace(/[^\d+]/g, '')}` : '#';
  const contactMainEmail = settings?.companyPrimaryEmail || (contactContent && contactContent.email) || settings?.contactMainEmail || 'enquiry@tiwarisyndicate.com';

  const contactGstin = settings?.companyGstin || (contactContent && contactContent.gstin) || '10AAJCT1476B1ZT';

  const contactAddressLine1 = settings?.companyAddress || (contactContent && contactContent.address) || settings?.contactAddressLine1 || 'Tiwari Syndicate Private Limited, Majhauli Khetal, Near Majhaulia Chowk, Majhaulia, Muzaffarpur, Bihar, 842001';
  const contactSecondaryAddress = settings?.companySecondaryAddress || '';
  const contactAddressLine2 = (contactContent && contactContent.addressLine2) || settings?.contactAddressLine2 || '';
  const contactHoursLine2 = (contactContent && contactContent.hoursLine2) || settings?.contactHoursLine2 || 'Sunday: Closed';
  const contactHoursLine1 = (contactContent && contactContent.hoursLine1) || settings?.contactHoursLine1 || 'Monday to Saturday : 9 AM - 7 PM';

  const contactSupportHeading = (contactContent && contactContent.supportHeading) || (settings && settings.contactSupportHeading) || 'Need Immediate Assistance?';
  const contactSupportSubtitle = (contactContent && contactContent.supportSubtitle) || (settings && settings.contactSupportSubtitle) || 'Our customer support team is available to help you right away.';
  
  const rawSupportPhone = settings?.companySupportPhone || contactMainPhoneLabel || '06214418345';
  const contactSupportPhoneLabel = rawSupportPhone ? (rawSupportPhone.toLowerCase().startsWith('call:') ? rawSupportPhone : `Call: ${rawSupportPhone}`) : '';
  const contactSupportPhoneHref = rawSupportPhone ? `tel:${rawSupportPhone.replace(/[^\d+]/g, '')}` : contactPhoneHref;
  const contactSupportCallbackLabel = (contactContent && contactContent.supportCallbackLabel) || (settings && settings.contactSupportCallbackLabel) || 'Request Callback';

  const directionsUrl = 'https://maps.app.goo.gl/SHQWREhHdb1gfF2TA';

  const officeLocations = [
    {
      city: 'Majhaulia (Muzaffarpur)',
      headOffice: true,
      address: 'Tiwari Syndicate Private Limited, Majhauli Khetal, Near Majhaulia Chowk, Majhaulia, Muzaffarpur, Bihar, 842001',
      gstin: contactGstin,
      phone: contactMainPhoneLabel,
      email: contactMainEmail,
      logo: delhiImage,
      color: '#e0f2fe',
    }
  ];



  return (

    <main

      className="contact-page"

      style={{

        background: "#ffffff",

        overflowX: "hidden",

      }}

    >

{/* HERO SECTION */}

<section

  className="contact-hero"

  style={{

    backgroundImage: contactHeroBackground,

  }}

>

  <div

    className="contact-hero__inner"

  >

    <span

      className="contact-hero__pill"

      style={{

        display: "inline-block",

        background: "#A8D08D",

        color: "#000",

        padding: "6px 14px",

        fontSize: "0.8rem",

        fontWeight: 600,

        borderRadius: "6px",

        marginBottom: "14px",

      }}

    >

      {heroBadge}

    </span>



    <h1

      style={{

        fontSize: "2.8rem",

        margin: "4px 0 16px",

        fontWeight: 700,

        lineHeight: 1.2,

      }}

    >

      {heroTitle}

    </h1>



    <p

      style={{

        maxWidth: "450px",

        color: "rgba(255,255,255,0.92)",

        lineHeight: 1.6,

        fontSize: "1rem",

      }}

    >

      {heroSubtitle}

    </p>

  </div>

</section>







      {/* BREADCRUMB */}

      <div

        style={{

          background: isNightMode ? "#1e293b" : "#fff",

          borderTop: isNightMode ? "1px solid #334155" : "1px solid rgba(0,0,0,0.06)",

          borderBottom: isNightMode ? "1px solid #334155" : "1px solid rgba(0,0,0,0.06)",

          padding: "12px 24px",

        }}

      >

        <div

          style={{

            maxWidth: "1200px",

            margin: "0 auto",

            color: isNightMode ? "#cbd5e1" : "#666",

            display: 'flex',

            alignItems: 'center',

            gap: 10,

            flexWrap: 'wrap',

          }}

        >

          <BackButton fallbackTo="/" />



          <NavLink

            to="/"

            style={{

              textDecoration: 'none',

              color: isNightMode ? '#cbd5e1' : '#666',

              fontWeight: 500,

              marginRight: 4,

            }}

          >

            HOME

          </NavLink>

          <span aria-hidden>›</span>{' '}

          <strong style={{ color: isNightMode ? "#fff" : "#000", marginLeft: 4 }}>Contact</strong>

        </div>

      </div>



      {/* CONTACT GRID */}

      <section

        className="contact-grid-section"

        style={{

          maxWidth: "1200px",

          margin: "40px auto",

          padding: "0 5%",

          width: "100%",

          boxSizing: "border-box"

        }}

      >

        <div

          className="contact-grid"

          style={{

            width: "100%",

            boxSizing: "border-box"

          }}

        >

          {/* PHONE */}

          <motion.div

            className="contact-card"

            style={{

              background: isNightMode ? "#1e293b" : "white",

              padding: "28px",

              borderRadius: "14px",

              boxShadow: isNightMode ? "0 8px 22px rgba(0,0,0,0.3)" : "0 8px 22px rgba(4,14,6,0.08)",

            }}

            initial={{ opacity: 0, y: 30 }}

            whileInView={{ opacity: 1, y: 0 }}

            viewport={{ once: true }}

            transition={{ duration: 0.5 }}

            whileHover={{ y: -5, scale: 1.02 }}

          >

            <div

              style={{

                width: "48px",

                height: "48px",

                borderRadius: "50%",

                background: "#E6F4EA",

                display: "flex",

                justifyContent: "center",

                alignItems: "center",

                marginBottom: "16px",

              }}

            >

              <PhoneCallSvgIcon width={24} height={24} stroke="#4A6640" />

            </div>



            <h3 style={{ marginBottom: 8, color: isNightMode ? "#f1f5f9" : "#1a1a1a" }}>Phone</h3>

            <p style={{ margin: "0 0 4px", color: isNightMode ? "#cbd5e1" : "#444" }}>

              {contactMainPhoneLabel}

            </p>

            <p style={{ margin: "0 0 18px", color: isNightMode ? "#cbd5e1" : "#444" }}>

              {contactAltPhoneLabel}

            </p>

            <button
              onClick={() => {
                window.location.href = contactPhoneHref;
              }}
              style={{
                color: "#4A6640",
                fontWeight: 600,
                textDecoration: "none",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 0,
                font: "inherit",
                display: "inline-block",
                marginTop: "auto",
                alignSelf: "flex-start",
              }}
              onMouseOver={(e) => {
                e.target.style.textDecoration = "underline";
              }}
              onMouseOut={(e) => {
                e.target.style.textDecoration = "none";
              }}
            >
              Call Now →
            </button>

          </motion.div>

          {/* EMAIL */}

          <motion.div

            className="contact-card"

            style={{

              background: isNightMode ? "#1e293b" : "white",

              padding: "28px",

              borderRadius: "14px",

              boxShadow: isNightMode ? "0 8px 22px rgba(0,0,0,0.3)" : "0 8px 22px rgba(4,14,6,0.08)",

            }}

            initial={{ opacity: 0, y: 30 }}

            whileInView={{ opacity: 1, y: 0 }}

            viewport={{ once: true }}

            transition={{ duration: 0.5, delay: 0.1 }}

            whileHover={{ y: -5, scale: 1.02 }}

          >

            <div

              style={{

                width: "48px",

                height: "48px",

                borderRadius: "50%",

                background: "#E6F4EA",

                display: "flex",

                justifyContent: "center",

                alignItems: "center",

                marginBottom: "16px",

              }}

            >

              <img

                src={`${process.env.PUBLIC_URL}/assets/images/ContactPageemail.png`}

                alt="Email"

                style={{ width: "55px" }}

              />

            </div>



            <h3 style={{ marginBottom: 8, color: isNightMode ? "#f1f5f9" : "#1a1a1a" }}>Email</h3>

            <p style={{ margin: "0 0 18px", color: isNightMode ? "#cbd5e1" : "#444", wordBreak: "break-word" }}>
              <button
                onClick={() => {
                  const subject = encodeURIComponent('Inquiry from Tiwari Syndicate Website');
                  const body = encodeURIComponent('Dear Tiwari Syndicate Team,\n\nI would like to inquire about your products/services.\n\nPlease provide me with more information.\n\nThank you!');
                  const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${contactMainEmail}&su=${subject}&body=${body}`;
                  window.open(gmailUrl, '_blank');
                }}
                style={{
                  color: isNightMode ? "#cbd5e1" : "#444",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                  font: "inherit",
                  textDecoration: "underline",
                  fontSize: "inherit",
                  lineHeight: "inherit",
                  wordBreak: "break-word",
                  maxWidth: "100%",
                }}
                onMouseOver={(e) => {
                  e.target.style.color = isNightMode ? "#f1f5f9" : "#1a1a1a";
                }}
                onMouseOut={(e) => {
                  e.target.style.color = isNightMode ? "#cbd5e1" : "#444";
                }}
              >
                {contactMainEmail}
              </button>
            </p>



            <button
              onClick={() => {
                const subject = encodeURIComponent('Inquiry from Tiwari Syndicate Website');
                const body = encodeURIComponent('Dear Tiwari Syndicate Team,\n\nI would like to inquire about your products/services.\n\nPlease provide me with more information.\n\nThank you!');
                const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${contactMainEmail}&su=${subject}&body=${body}`;
                window.open(gmailUrl, '_blank');
              }}
              style={{
                color: "#4A6640",
                fontWeight: 600,
                textDecoration: "none",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 0,
                font: "inherit",
                display: "inline-block",
                marginTop: "auto",
                alignSelf: "flex-start",
              }}
              onMouseOver={(e) => {
                e.target.style.textDecoration = "underline";
              }}
              onMouseOut={(e) => {
                e.target.style.textDecoration = "none";
              }}
            >
              Send Email →
            </button>

          </motion.div>



          {/* ADDRESS */}

          <motion.div

            className="contact-card"

            style={{

              background: isNightMode ? "#1e293b" : "white",

              padding: "28px",

              borderRadius: "14px",

              boxShadow: isNightMode ? "0 8px 22px rgba(0,0,0,0.3)" : "0 8px 22px rgba(4,14,6,0.08)",

            }}

            initial={{ opacity: 0, y: 30 }}

            whileInView={{ opacity: 1, y: 0 }}

            viewport={{ once: true }}

            transition={{ duration: 0.5, delay: 0.2 }}

            whileHover={{ y: -5, scale: 1.02 }}

          >

            <div

              style={{

                width: "48px",

                height: "48px",

                borderRadius: "50%",

                background: "#E6F4EA",

                display: "flex",

                justifyContent: "center",

                alignItems: "center",

                marginBottom: "16px",

              }}

            >

              <img

                src={`${process.env.PUBLIC_URL}/assets/images/ContactPagelocation.png`}

                alt="Location"

                style={{ width: "55px" }}

              />

            </div>



            <h3 style={{ marginBottom: 8, color: isNightMode ? "#f1f5f9" : "#1a1a1a" }}>Address</h3>

            <p style={{ margin: "0 0 18px", color: isNightMode ? "#cbd5e1" : "#444" }}>

              {contactAddressLine1}

            </p>

            {contactAddressLine2 && !contactAddressLine1.includes('842001') && (
              <p style={{ margin: "0 0 18px", color: isNightMode ? "#cbd5e1" : "#444" }}>
                {contactAddressLine2}
              </p>
            )}

            <a
              href={directionsUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#4A6640",
                fontWeight: 600,
                textDecoration: "none",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 0,
                font: "inherit",
                display: "inline-block",
                marginTop: "auto",
                alignSelf: "flex-start",
              }}
              onMouseOver={(e) => {
                e.target.style.textDecoration = "underline";
              }}
              onMouseOut={(e) => {
                e.target.style.textDecoration = "none";
              }}
            >
              Get Directions →
            </a>

          </motion.div>



          {/* WORKING HOURS */}

          <motion.div

            className="contact-card"

            style={{

              background: isNightMode ? "#1e293b" : "white",

              padding: "28px",

              borderRadius: "14px",

              boxShadow: isNightMode ? "0 8px 22px rgba(0,0,0,0.3)" : "0 8px 22px rgba(4,14,6,0.08)",

            }}

            initial={{ opacity: 0, y: 30 }}

            whileInView={{ opacity: 1, y: 0 }}

            viewport={{ once: true }}

            transition={{ duration: 0.5, delay: 0.3 }}

            whileHover={{ y: -5, scale: 1.02 }}

          >

            <div

              style={{

                width: "48px",

                height: "48px",

                borderRadius: "50%",

                background: "#E6F4EA",

                display: "flex",

                justifyContent: "center",

                alignItems: "center",

                marginBottom: "16px",

              }}

            >

              <img

                src={`${process.env.PUBLIC_URL}/assets/images/ContactPageclock.png`}

                alt="Clock"

                style={{ width: "55px" }}

              />

            </div>



            <h3 style={{ marginBottom: 8, color: isNightMode ? "#f1f5f9" : "#1a1a1a" }}>Working Hours</h3>

            <p style={{ margin: "0 0 4px", color: isNightMode ? "#cbd5e1" : "#444" }}>

              {contactHoursLine1}

            </p>

            <p style={{ margin: "0 0 18px", color: isNightMode ? "#cbd5e1" : "#444" }}>

              {contactHoursLine2}

            </p>



            <span style={{ color: "#4A6640", fontWeight: 600, marginTop: "auto", alignSelf: "flex-start", display: "inline-block" }}>—</span>

          </motion.div>

        </div>

      </section>



      {/* CONTACT FORM + MAP + ASSISTANCE */}

      <section

        style={{

          maxWidth: "1200px",

          margin: "60px auto 80px",

          padding: "0 40px",

          width: "100%",

          boxSizing: "border-box"

        }}

      >

  <div

    style={{

      display: "grid",

      gridTemplateColumns: "1fr 380px",

      gap: "40px",

      alignItems: "start",

      width: "100%",

      maxWidth: "1200px",

      margin: "0 auto",

      boxSizing: "border-box"

    }}

    className="contact-container"

  >

    {/* LEFT: FORM */}

    <motion.div 

      className="contact-form"

      style={{

        background: isNightMode ? "#1e293b" : "#fff",

        borderRadius: "12px",

        padding: "40px",

        boxShadow: isNightMode ? "0 4px 20px rgba(0,0,0,0.3)" : "0 4px 20px rgba(0,0,0,0.05)",

        border: isNightMode ? "1px solid #334155" : "1px solid rgba(0,0,0,0.05)",

        width: "100%"

      }}

      initial={{ opacity: 0, x: -30 }}

      animate={{ opacity: 1, x: 0 }}

      viewport={{ once: true }}

      transition={{ duration: 0.6 }}

    >

      <div style={{ marginBottom: 18 }}>

        <span

          style={{

            display: "inline-block",

            background: "#A8D08D",

            color: "#2C5A31",

            padding: "6px 10px",

            borderRadius: 8,

            fontSize: 13,

            marginBottom: 8,

          }}

        >

          Send Message

        </span>



        <h2 style={{ fontSize: 32, margin: "8px 0 6px", color: isNightMode ? "#f1f5f9" : "#1a1a1a" }}>

          We'd Love to Hear From You

        </h2>



        <p style={{ color: isNightMode ? "#cbd5e1" : "#555", marginBottom: 18 }}>

          Fill out the form below and our team will get back to you within 24

          hours.

        </p>

      </div>



      {submitStatus && (

        <div style={{

          padding: "12px 16px",

          borderRadius: "8px",

          marginBottom: "18px",

          textAlign: "center",

          fontWeight: "500",

          background: submitStatus.includes('successfully') ? "#d4edda" : 
                   submitStatus.includes('Sending') ? "#d1ecf1" : "#f8d7da",

          color: submitStatus.includes('successfully') ? "#155724" : 
                 submitStatus.includes('Sending') ? "#0c5460" : "#721c24",

          border: `1px solid ${
            submitStatus.includes('successfully') ? "#c3e6cb" : 
            submitStatus.includes('Sending') ? "#bee5eb" : "#f5c6cb"
          }`

        }}>

          {submitStatus}

        </div>

      )}



      <form onSubmit={handleSubmit}>

      <div className="form-grid">

        <div>

          <label style={{ display: "block", fontSize: 13, marginBottom: 8, color: isNightMode ? "#cbd5e1" : "#1a1a1a" }}>

            Full Name *

          </label>

          <input

            type="text"

            name="name"

            value={formData.name}

            onChange={handleInputChange}

            placeholder="John Doe"

            required

            style={{

              width: "100%",

              padding: "14px 16px",

              borderRadius: 8,

              border: isNightMode ? "1px solid #334155" : "1px solid rgba(0,0,0,0.06)",

              background: isNightMode ? "#0f172a" : "#f6f6f6",

              color: isNightMode ? "#f1f5f9" : "#1a1a1a",

            }}

          />

        </div>



        <div>

          <label style={{ display: "block", fontSize: 13, marginBottom: 8, color: isNightMode ? "#cbd5e1" : "#1a1a1a" }}>

            Email Address *

          </label>

          <input

            type="email"

            name="email"

            value={formData.email}

            onChange={handleInputChange}

            placeholder="john@example.com"

            required

            style={{

              width: "100%",

              padding: "14px 16px",

              borderRadius: 8,

              border: isNightMode ? "1px solid #334155" : "1px solid rgba(0,0,0,0.06)",

              background: isNightMode ? "#0f172a" : "#f6f6f6",

              color: isNightMode ? "#f1f5f9" : "#1a1a1a",

            }}

          />

        </div>

      </div>



      <div className="form-grid">

        <div>

          <label style={{ display: "block", fontSize: 13, marginBottom: 8, color: isNightMode ? "#cbd5e1" : "#1a1a1a" }}>

            Phone Number *

          </label>

          <input

            type="tel"

            name="phone"

            value={formData.phone}

            onChange={handleInputChange}

            placeholder="+91 1234567890"

            required

            style={{

              width: "100%",

              padding: "14px 16px",

              borderRadius: 8,

              border: isNightMode ? "1px solid #334155" : "1px solid rgba(0,0,0,0.06)",

              background: isNightMode ? "#0f172a" : "#f6f6f6",

              color: isNightMode ? "#f1f5f9" : "#1a1a1a",

            }}

          />

        </div>



        <div>

          <label style={{ display: "block", fontSize: 13, marginBottom: 8, color: isNightMode ? "#cbd5e1" : "#1a1a1a" }}>

            Subject *

          </label>

          <input

            type="text"

            name="subject"

            value={formData.subject}

            onChange={handleInputChange}

            placeholder="Inquiry about..."

            required

            style={{

              width: "100%",

              padding: "14px 16px",

              borderRadius: 8,

              border: isNightMode ? "1px solid #334155" : "1px solid rgba(0,0,0,0.06)",

              background: isNightMode ? "#0f172a" : "#f6f6f6",

              color: isNightMode ? "#f1f5f9" : "#1a1a1a",

            }}

          />

        </div>

      </div>



      <div style={{ marginBottom: 14 }}>

        <label style={{ display: "block", fontSize: 13, marginBottom: 8, color: isNightMode ? "#cbd5e1" : "#1a1a1a" }}>

          Message *

        </label>

        <textarea

          name="message"

          value={formData.message}

          onChange={handleInputChange}

          placeholder="Tell us more about your requirements..."

          required

          style={{

            width: "100%",

            minHeight: 150,

            padding: "16px",

            borderRadius: 10,

            border: isNightMode ? "1px solid #334155" : "1px solid rgba(0,0,0,0.06)",

            background: isNightMode ? "#0f172a" : "#f6f6f6",

            color: isNightMode ? "#f1f5f9" : "#1a1a1a",

            resize: "vertical",

          }}

        />

      </div>



      <div>

        <motion.button

          type="submit"

          style={{

            width: "100%",

            padding: "14px 18px",

            borderRadius: 8,

            border: "none",

            background: "#A8D08D",

            color: "#0b2a0b",

            fontWeight: 700,

            display: "flex",

            alignItems: "center",

            justifyContent: "center",

            gap: 10,

            cursor: "pointer",

            boxShadow: "inset 0 -4px 0 rgba(0,0,0,0.03)",

          }}

          whileHover={{ scale: 1.02, y: -2 }}

          whileTap={{ scale: 0.98 }}

          transition={{ type: "spring", stiffness: 400, damping: 17 }}

        >

          <span>Send Message</span>

        </motion.button>

      </div>

      </form>

    </motion.div>



    {/* RIGHT: ASSISTANCE CARD */}

    <motion.div style={{ 

      display: "flex", 

      flexDirection: "column", 

      gap: "24px",

      position: "sticky",

      top: "40px"

    }}
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >

      {/* ASSISTANCE CARD */}

      <motion.div

        style={{

          background: "linear-gradient(135deg, #5D7F4E 0%, #3E5C32 100%)",

          color: "white",

          borderRadius: "12px",

          padding: "32px",

          boxShadow: "0 8px 32px rgba(39,55,33,0.15)",

          border: "1px solid rgba(255,255,255,0.1)",

          width: "100%",

          boxSizing: "border-box"

        }}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.2 }}
        whileHover={{ scale: 1.02, y: -5 }}
      >

        <h3 style={{ margin: "2px 0 8px", fontSize: 20 }}>{contactSupportHeading}</h3>

        <p style={{ margin: "0 0 16px", opacity: 0.95 }}>

          {contactSupportSubtitle}

        </p>



        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>

          <motion.a

            href={contactSupportPhoneHref}

            style={{

              display: "flex",

              alignItems: "center",

              justifyContent: "center",

              gap: 12,

              background: "white",

              color: "#1f3a21",

              padding: "12px 14px",

              borderRadius: 8,

              textDecoration: "none",

              fontWeight: 700,

            }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 400, damping: 17 }}
          >

            <PhoneCallSvgIcon width={16} height={16} stroke="currentColor" />

            <span>{contactSupportPhoneLabel}</span>

          </motion.a>

          <motion.button

            onClick={() => setShowCallbackModal(true)}

            style={{

              display: "block",

              background: "rgba(255,255,255,0.95)",

              color: "#1f3a21",

              padding: "12px 14px",

              borderRadius: 8,

              textDecoration: "none",

              fontWeight: 700,

              textAlign: "center",

              border: "none",

              cursor: "pointer",

            }}

            whileHover={{ scale: 1.05 }}

            whileTap={{ scale: 0.95 }}

            transition={{ type: "spring", stiffness: 400, damping: 17 }}

          >

            {contactSupportCallbackLabel}

          </motion.button>

        </div>

      </motion.div>

    </motion.div>



<style>{`

  /* Base styles for contact form */

  .contact-container {

    transition: all 0.3s ease;

  }



  /* Desktop styles */

  @media (min-width: 1024px) {

    .contact-container {

      grid-template-columns: 1fr 400px !important;

    }

    

    .contact-form {

      padding: 48px !important;

    }

    

    .form-grid {

      display: grid;

      grid-template-columns: 1fr 1fr;

      gap: 20px;

      margin-bottom: 20px;

    }

    

    .full-width {

      grid-column: 1 / -1;

    }

  }

  

  /* Tablet styles */

  @media (max-width: 1023px) and (min-width: 768px) {

    .contact-container {

      grid-template-columns: 1fr !important;

      gap: 32px !important;

    }

    

    .form-grid {

      display: grid;

      grid-template-columns: 1fr 1fr;

      gap: 16px;

      margin-bottom: 16px;

    }

  }

  

  /* Mobile styles */

  @media (max-width: 767px) {

    .contact-container {

      grid-template-columns: 1fr !important;

      padding: 0 16px !important;

      gap: 24px !important;

    }

    

    .form-grid {

      display: flex;

      flex-direction: column;

      gap: 16px;

      margin-bottom: 16px;

    }

    

    .contact-container input,

    .contact-container textarea,

    .contact-container button {

      width: 100% !important;

    }

    

    .contact-container h2 {

      font-size: 24px !important;

      line-height: 1.3 !important;

    }

  }

  

  /* Form element styles */

  .form-group {

    margin-bottom: 16px;

  }

  

  .form-group label {

    display: block;

    margin-bottom: 8px;

    font-weight: 500;

    color: #333;

  }

  

  .form-control {

    width: 100%;

    padding: 12px 16px;

    border: 1px solid #ddd;

    border-radius: 8px;

    font-size: 15px;

    transition: all 0.2s ease;

    background: #f9f9f9;

  }

  

  .form-control:focus {

    outline: none;

    border-color: #5D7F4E;

    box-shadow: 0 0 0 2px rgba(93, 127, 78, 0.1);

    background: #fff;

  }

  

  textarea.form-control {

    min-height: 150px;

    resize: vertical;

  }

  

  .btn-primary {

    background: #5D7F4E;

    color: white;

    border: none;

    padding: 14px 24px;

    border-radius: 8px;

    font-weight: 600;

    cursor: pointer;

    transition: all 0.2s ease;

    width: 100%;

    font-size: 16px;

  }

  

  .btn-primary:hover {

    background: #4a6a3d;

    transform: translateY(-1px);

    box-shadow: 0 4px 12px rgba(93, 127, 78, 0.2);

  }

`}</style>



</div>

</section>

{/* OUR OFFICES */}

<section

  className="offices-section"

  style={{

    maxWidth: "1200px",

    margin: "60px auto",

    padding: "0 20px",

    textAlign: "center",

  }}

>

  {/* Badge */}

  <span

    style={{

      display: "inline-block",

      background: "#A8D08D",

      color: "#000000",

      padding: "6px 14px",

      fontSize: "0.85rem",

      borderRadius: "6px",

      marginBottom: "14px",

      fontWeight: "500",

    }}

  >

    Our Locations

  </span>



  <h2 style={{ 

    fontSize: "2rem", 

    marginBottom: "8px",

    color: isNightMode ? "#e5e7eb" : "#1e293b",

    fontWeight: "700"

  }}>

    Visit Our Offices

  </h2>



  <p style={{ 

    color: isNightMode ? "#cbd5f5" : "#64748b", 

    marginBottom: "60px",

    fontSize: "1.1rem",

    maxWidth: "500px",

    margin: "0 auto 60px",

    lineHeight: "1.6"

  }}>

    We have offices across major cities to serve you better

  </p>



  {/* Office Cards Grid */}

  <div

    className="offices-grid"

    style={{

      width: "100%",

      boxSizing: "border-box",

    }}

  >

    {officeLocations.map((office, idx) => (

      <div

        key={idx}

        className="offices-card"

        style={{

          background: isNightMode ? "#1e293b" : "white",

          textAlign: "left",

          padding: "24px",

          borderRadius: "12px",

          boxShadow: isNightMode ? "0 4px 12px rgba(0,0,0,0.3)" : "0 4px 12px rgba(0,0,0,0.08)",

          border: isNightMode ? "1px solid #334155" : "1px solid #e5e7eb",

          display: "flex",

          flexDirection: "column",

          gap: "16px",

          minHeight: "220px",

          transition: "all 0.3s ease",

          width: "380px",

          maxWidth: "380px",

          boxSizing: "border-box",

        }}

        onMouseEnter={(e) => {

          e.currentTarget.style.transform = "translateY(-4px)";

          e.currentTarget.style.boxShadow = "0 12px 28px rgba(0,0,0,0.12)";

        }}

        onMouseLeave={(e) => {

          e.currentTarget.style.transform = "translateY(0)";

          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)";

        }}

      >

        {/* City + Icon Row */}

        <div

          style={{

            display: "flex",

            alignItems: "center",

            gap: "12px",

            marginBottom: "4px",

          }}

        >

          <div

            style={{

              width: "44px",

              height: "44px",

              borderRadius: "10px",

              background: office.color,

              display: "flex",

              justifyContent: "center",

              alignItems: "center",

              flexShrink: 0,

            }}

          >

            <img

              src={office.logo}

              alt="Office icon"

              style={{ width: "22px", height: "22px" }}

            />

          </div>



          <div>

            <h3

              style={{

                margin: 0,

                fontSize: "1.1rem",

                fontWeight: "600",

                color: isNightMode ? "#f1f5f9" : "#111827",

                lineHeight: "1.3",

              }}

            >

              {office.city}

            </h3>

            {office.headOffice && (

              <div

                style={{

                  fontSize: "0.75rem",

                  color: "#3b82f6",

                  fontWeight: "600",

                  marginTop: "2px",

                }}

              >

                Head Office (Registered Office)

              </div>

            )}

          </div>

        </div>



        {/* Contact Details */}

        <div

          style={{

            display: "flex",

            flexDirection: "column",

            gap: "12px",

            flexGrow: 1,

          }}

        >

          {/* Address */}

          <div

            style={{

              display: "flex",

              alignItems: "flex-start",

              gap: "10px",

            }}

          >

            <a

              href={directionsUrl}

              target="_blank"

              rel="noopener noreferrer"

              style={{

                color: isNightMode ? "#cbd5e1" : "#4b5563",

                lineHeight: "1.4",

                fontWeight: "400",

                fontSize: "0.9rem",

                textDecoration: "none",

              }}

              onMouseEnter={(e) => {

                e.currentTarget.style.textDecoration = "underline";

              }}

              onMouseLeave={(e) => {

                e.currentTarget.style.textDecoration = "none";

              }}

            >

              {office.address}

            </a>

          </div>



          <div

            style={{

              marginTop: 4,

            }}

          >

            <a

              href={directionsUrl}

              target="_blank"

              rel="noopener noreferrer"

              style={{

                display: 'inline-flex',

                alignItems: 'center',

                gap: 6,

                color: '#16a34a',

                fontSize: '0.85rem',

                fontWeight: 600,

                textDecoration: 'none',

              }}

            >

              <span aria-hidden="true" style={{ fontSize: '1rem' }}>📍</span>

              <span>View on Map</span>

            </a>

          </div>

          {(office.gstin || contactGstin) && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <span aria-hidden="true" style={{ fontSize: '1rem', lineHeight: 1 }}>📋</span>
              <div
                style={{
                  color: isNightMode ? "#cbd5e1" : "#4b5563",
                  lineHeight: "1.4",
                  fontWeight: "400",
                  fontSize: "0.9rem",
                }}
              >
                <strong style={{ color: isNightMode ? "#f1f5f9" : "#111827" }}>GSTIN:</strong>{' '}
                <span style={{ fontFamily: "monospace", letterSpacing: "0.5px", fontWeight: 600 }}>
                  {office.gstin || contactGstin}
                </span>
              </div>
            </div>
          )}



          {/* Phone */}

          <div

            style={{

              display: "flex",

              alignItems: "center",

              gap: "10px",

            }}

          >

            <PhoneCallSvgIcon width={16} height={16} stroke={isNightMode ? "#cbd5e1" : "#4b5563"} />

            <div

              style={{

                color: isNightMode ? "#cbd5e1" : "#4b5563",

                lineHeight: "1.4",

                fontWeight: "400",

                fontSize: "0.9rem",

              }}

            >

              {office.phone}

            </div>

          </div>



          {/* Email */}

          <div

            style={{

              display: "flex",

              alignItems: "center",

              gap: "10px",

            }}

          >

            <span aria-hidden="true" style={{ fontSize: '1rem' }}>✉️</span>

            <button
              onClick={() => {
                const subject = encodeURIComponent('Inquiry from Tiwari Syndicate Website');
                const body = encodeURIComponent('Dear Tiwari Syndicate Team,\n\nI would like to inquire about your products/services.\n\nPlease provide me with more information.\n\nThank you!');
                const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${office.email}&su=${subject}&body=${body}`;
                window.open(gmailUrl, '_blank');
              }}
              style={{
                color: "#3b82f6",
                lineHeight: "1.4",
                fontWeight: "400",
                fontSize: "0.9rem",
                textDecoration: "none",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 0,
                font: "inherit",
                wordBreak: "break-word",
                maxWidth: "100%",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = "underline";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = "none";
              }}
            >
              {office.email}
            </button>

          </div>

        </div>

      </div>

    ))}

  </div>

</section>

{/* FAQ SECTION */}

<section

  className="contact-faq"

  style={{

    background: isNightMode ? "#0f172a" : "#f8faf8",

    padding: "60px 20px",

    marginTop: 40,

  }}

>

  <div className="contact-faq__inner" style={{ maxWidth: 1100, margin: "0 auto", textAlign: "center" }}>

    <span

      style={{

        display: "inline-block",

        background: "#E6F4EA",

        color: "#3C7F39",

        padding: "6px 12px",

        fontSize: "0.85rem",

        borderRadius: "6px",

        marginBottom: 12,

      }}

    >

      FAQ

    </span>



    <h2 style={{ fontSize: "2rem", margin: "8px 0 8px", color: isNightMode ? "#f1f5f9" : "#1a1a1a" }}>

      Frequently Asked Questions

    </h2>



    <p style={{ color: isNightMode ? "#cbd5e1" : "#556", marginBottom: 30 }}>

      Quick answers to common questions

    </p>



    {/* FAQ Cards */}

    {(settings?.contactFaqItems && settings.contactFaqItems.length > 0 ? settings.contactFaqItems : [
        {
          q: "Do you offer bulk discounts?",
          a: "Yes, we offer competitive pricing for bulk orders. Contact our sales team for a custom quote.",
        },
        {
          q: "What is your delivery timeframe?",
          a: "Delivery typically takes 3-7 business days depending on your location and product availability.",
        },
        {
          q: "Do you provide installation services?",
          a: "Yes, we offer professional installation services for most of our products. Contact us for details.",
        },
      ]).map((item, idx) => (

      <div

        key={idx}

        className="contact-faq__card"

        style={{

          background: isNightMode ? "#1e293b" : "#fff",

          padding: "22px",

          borderRadius: "12px",

          boxShadow: isNightMode ? "0 6px 18px rgba(0,0,0,0.3)" : "0 6px 18px rgba(0,0,0,0.06)",

          maxWidth: 900,

          margin: "0 auto 16px",

          textAlign: "left",

        }}

      >

        <h3 style={{ marginBottom: 8, fontSize: "1rem", color: isNightMode ? "#f1f5f9" : "#1a1a1a" }}>{item.q}</h3>

        <p style={{ margin: 0, color: isNightMode ? "#cbd5e1" : "#555", lineHeight: 1.6 }}>{item.a}</p>

      </div>

    ))}



    {/* Footer */}

    <div style={{ marginTop: 20 }}>

      <p style={{ color: isNightMode ? "#cbd5e1" : "#667", marginBottom: 8 }}>Still have questions?</p>

      <NavLink

        to="/faq"

        style={{

          display: "inline-block",

          padding: "8px 14px",

          borderRadius: 8,

          background: isNightMode ? "#1e293b" : "#fff",

          color: "#4A6640",

          textDecoration: "none",

          boxShadow: isNightMode ? "0 6px 18px rgba(0,0,0,0.3)" : "0 6px 18px rgba(0,0,0,0.06)",

          fontWeight: 600,

        }}

      >

        View All FAQs

      </NavLink>

    </div>

  </div>

</section>

{/* CTA SECTION */}

<section

  className="contact-cta"

  style={{

    background: "linear-gradient(180deg, #0A0F14, #000000)",

    padding: "70px 20px",

    marginTop: "40px",

    textAlign: "center",

    color: "white",

  }}

>



  <div className="contact-cta__inner" style={{ maxWidth: 900, margin: "0 auto" }}>

    <h2 style={{ fontSize: "2rem", marginBottom: "14px" }}>

      Ready to Get Started?

    </h2>



    <p style={{ maxWidth: 600, margin: "0 auto 30px", color: "rgba(255,255,255,0.85)", lineHeight: 1.6 }}>

      Browse our extensive catalog or speak with our experts to find the perfect materials

      for your project

    </p>



    <div

      className="contact-cta__buttons"

      style={{

        display: "flex",

        justifyContent: "center",

        gap: "16px",

        marginTop: "10px",

      }}

    >

      {/* Browse Products */}

      <NavLink

        to="/products"

        style={{

          background: "#A8D08D",

          color: "#0b2a0b",

          padding: "12px 22px",

          borderRadius: "10px",

          textDecoration: "none",

          fontWeight: 600,

          boxShadow: "0 2px 10px rgba(0,0,0,0.15)",

        }}

      >

        Browse Products

      </NavLink>



      {/* Our Services */}

      <NavLink

        to="/services"

        style={{

          border: "1px solid rgba(255,255,255,0.8)",

          color: "white",

          padding: "12px 22px",

          borderRadius: "10px",

          textDecoration: "none",

          fontWeight: 600,

        }}

      >

        Our Services

      </NavLink>

    </div>

  </div>

</section>

      {/* Callback Modal */}
      {showCallbackModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}
          onClick={() => setShowCallbackModal(false)}
        >
          <div
            style={{
              backgroundColor: isNightMode ? '#1e293b' : '#fff',
              borderRadius: '8px',
              padding: '24px',
              maxWidth: '400px',
              width: '90%',
              position: 'relative',
              boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setShowCallbackModal(false)}
              style={{
                position: 'absolute',
                top: '12px',
                right: '12px',
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: isNightMode ? '#cbd5e1' : '#666'
              }}
            >
              ×
            </button>

            {/* Modal Header */}
            <h2 style={{ 
              marginBottom: '20px', 
              color: isNightMode ? '#f1f5f9' : '#1a1a1a',
              fontSize: '20px',
              fontWeight: '600',
              textAlign: 'center'
            }}>
              Request Callback
            </h2>

            {/* Status Message */}
            {callbackStatus && (
              <div style={{
                padding: '10px 12px',
                borderRadius: '6px',
                marginBottom: '16px',
                fontSize: '14px',
                textAlign: 'center',
                fontWeight: '500',
                background: callbackStatus.includes('successfully') ? '#d4edda' : 
                           callbackStatus.includes('Submitting') ? '#d1ecf1' : '#f8d7da',
                color: callbackStatus.includes('successfully') ? '#155724' : 
                       callbackStatus.includes('Submitting') ? '#0c5460' : '#721c24',
                border: `1px solid ${
                  callbackStatus.includes('successfully') ? '#c3e6cb' : 
                  callbackStatus.includes('Submitting') ? '#bee5eb' : '#f5c6cb'
                }`
              }}>
                {callbackStatus}
              </div>
            )}

            {/* Form Fields */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label style={{ 
                  display: 'block', 
                  marginBottom: '6px',
                  color: isNightMode ? '#cbd5e1' : '#333',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  Name *
                </label>
                <input
                  type="text"
                  value={callbackData.name}
                  onChange={(e) => setCallbackData({...callbackData, name: e.target.value})}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: `1px solid ${isNightMode ? '#475569' : '#ddd'}`,
                    borderRadius: '6px',
                    fontSize: '14px',
                    backgroundColor: isNightMode ? '#334155' : '#fff',
                    color: isNightMode ? '#f1f5f9' : '#333'
                  }}
                  placeholder="Enter your name"
                  required
                />
              </div>

              <div>
                <label style={{ 
                  display: 'block', 
                  marginBottom: '6px',
                  color: isNightMode ? '#cbd5e1' : '#333',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  Email
                </label>
                <input
                  type="email"
                  value={callbackData.email}
                  onChange={(e) => setCallbackData({...callbackData, email: e.target.value})}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: `1px solid ${isNightMode ? '#475569' : '#ddd'}`,
                    borderRadius: '6px',
                    fontSize: '14px',
                    backgroundColor: isNightMode ? '#334155' : '#fff',
                    color: isNightMode ? '#f1f5f9' : '#333'
                  }}
                  placeholder="Enter your email"
                />
              </div>

              <div>
                <label style={{ 
                  display: 'block', 
                  marginBottom: '6px',
                  color: isNightMode ? '#cbd5e1' : '#333',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  Phone *
                </label>
                <input
                  type="tel"
                  value={callbackData.phone}
                  onChange={(e) => setCallbackData({...callbackData, phone: e.target.value})}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: `1px solid ${isNightMode ? '#475569' : '#ddd'}`,
                    borderRadius: '6px',
                    fontSize: '14px',
                    backgroundColor: isNightMode ? '#334155' : '#fff',
                    color: isNightMode ? '#f1f5f9' : '#333'
                  }}
                  placeholder="Enter your phone number"
                  required
                />
              </div>

              <div>
                <label style={{ 
                  display: 'block', 
                  marginBottom: '6px',
                  color: isNightMode ? '#cbd5e1' : '#333',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  Preferred Time
                </label>
                <select
                  value={callbackData.preferredTime}
                  onChange={(e) => setCallbackData({...callbackData, preferredTime: e.target.value})}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: `1px solid ${isNightMode ? '#475569' : '#ddd'}`,
                    borderRadius: '6px',
                    fontSize: '14px',
                    backgroundColor: isNightMode ? '#334155' : '#fff',
                    color: isNightMode ? '#f1f5f9' : '#333'
                  }}
                >
                  <option value="">Select preferred time</option>
                  <option value="9-10">9:00 AM - 10:00 AM</option>
                  <option value="10-11">10:00 AM - 11:00 AM</option>
                  <option value="11-12">11:00 AM - 12:00 PM</option>
                  <option value="12-1">12:00 PM - 1:00 PM</option>
                  <option value="1-2">1:00 PM - 2:00 PM</option>
                  <option value="2-3">2:00 PM - 3:00 PM</option>
                  <option value="3-4">3:00 PM - 4:00 PM</option>
                  <option value="4-5">4:00 PM - 5:00 PM</option>
                  <option value="5-6">5:00 PM - 6:00 PM</option>
                  <option value="6-7">6:00 PM - 7:00 PM</option>
                </select>
              </div>

              <div>
                <label style={{ 
                  display: 'block', 
                  marginBottom: '6px',
                  color: isNightMode ? '#cbd5e1' : '#333',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  Message
                </label>
                <textarea
                  value={callbackData.message}
                  onChange={(e) => setCallbackData({...callbackData, message: e.target.value})}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: `1px solid ${isNightMode ? '#475569' : '#ddd'}`,
                    borderRadius: '6px',
                    fontSize: '14px',
                    backgroundColor: isNightMode ? '#334155' : '#fff',
                    color: isNightMode ? '#f1f5f9' : '#333',
                    minHeight: '80px',
                    resize: 'vertical'
                  }}
                  placeholder="Briefly describe your requirements..."
                />
              </div>

              {/* Submit Button */}
              <button
                type="button"
                className="no-popup-submit"
                onClick={handleSubmitCallback}
                style={{
                  width: '100%',
                  padding: '12px',
                  borderRadius: '6px',
                  border: 'none',
                  background: '#16a34a',
                  color: 'white',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s'
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#15803d'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#16a34a'}
              >
                Request Callback
              </button>
            </div>
          </div>
        </div>
      )}

    </main>

  );

}


